import {
	Confirmation, connectedComponent, List, SortableTable,
	Form, FormGroupInputControl, Selector, loadFacilities,BodyClickListener, LoadingOverlay, Loader,
	NpiComponent
} from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { parse, stringify } from 'query-string';
import React, { Component } from 'react';
import TableAddress from '../../Util/TableAddress.react';
import '../subscription.scss';
import {
	createSubscription,
	deleteSubscription,
	deleteSubscriptionWithStatus,
	fetchSubscriptions,
	subscriptionOptIn,
	subscriptionOptOut,
	sendResubscribeEmail,
	updateNpiComment,
	createNPIComment,
	deleteNpiComment
} from '../subscriptions.actions';
import SubscriptionAddresses from './SubscriptionAddresses.react';

/**
 * A list of subscriptions for a given community
 *
 * @class SubscriptionList
 * @extends {Component}
 */
class SubscriptionList extends Component {
	constructor(props) {
		super(props);
		this.onClickDelete = this.onClickDelete.bind(this);
		this.discardConfirmation = this.discardConfirmation.bind(this);
		this.onSelectStatusFilter = this.onSelectStatusFilter.bind(this);
		this.onClickRefresh = this.onClickRefresh.bind(this);
		this.onClickAdvanceSearch = this.onClickAdvanceSearch.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSendingFacility = this.handleSendingFacility.bind(this);
		this.discardAdvancedSearch = this.discardAdvancedSearch.bind(this);
		this.handleAdvancedSearchSubmit = this.handleAdvancedSearchSubmit.bind(this);
		this.closeAdvancedSearch= this.closeAdvancedSearch.bind(this);
		this.handleMoreOptionsStyling=this.handleMoreOptionsStyling.bind(this); 
		this.exportData = this.exportData.bind(this);

		this.handleSort=this.handleSort.bind(this);
		this.onSelectSize=this.onSelectSize.bind(this);
		this.npiCommentCreate = this.npiCommentCreate.bind(this);
		this.npiCommentUpdate = this.npiCommentUpdate.bind(this);
		this.npiCommentDelete = this.npiCommentDelete.bind(this);
		this.state = {
			subscriptions: props.subscriptions,
			confirmation: null,
			showAdvancedSearch: false,
			buttonsDisabled: false,
			subscriptionsDownloadUrl: null,
			moreOptionsStyling:{},
			status:props.status,
			filter: {
				componentClass: 'input',
				id: 'subscription-filter',
				onChange: (value) => this.setState((prevState) => ({
					filter: { ...prevState.filter, value: value ? value.target && value.target.value : '' }
				})),
				onFilter: (value) => {
					this.closeAdvancedSearch();
					this.props.history.push(`?${stringify({
						...this.props.query,
						filterString: value,
						providerNpi: '',
						directAddress: '',
						sendingFacilityDisplayName: '',
						firstName: '',
						lastName: '',
						organizationName: ''
					})}`)
				},
				placeholder: 'Search (NPI, Name, Sending Facility, Direct Address)',
				filterButtonIcon: 'search',
				value: props.query.filterString
			},
			advancedSearch: {
				providerNpi: '',
				directAddress: '',
				sendingFacilityDisplayName: 'All',
				firstName: '',
				lastName: '',
				organizationName: ''
			}
		};
		this.sections = {
			common: {
				fields: {
					providerNpi: {
						label: 'NPI',
						style: 'col-md-4'
					},
					directAddress: {
						label: 'Direct Address',
						style: 'col-md-4'
					},
					sendingFacilityDisplayName: {
						label: 'Sending Facility',
						style: 'col-md-4',
						component: Selector,
						onChange: this.handleSendingFacility,
						value: 'sendingFacilitySelector',
						options: []
					},
					firstName: {
						label: 'First Name',
						style: 'col-md-4'
					},
					lastName: {
						label: 'Last Name',
						style: 'col-md-4'
					},
					organizationName: {
						label: 'Organization Name',
						style: 'col-md-4'
					}
				}
			}
		}
	}

	componentDidMount() {
		this.props.fetchSubscriptions({...this.props.query,status:this.props.status});
		this.props.fetchSendingFacilities({...this.props.query, size:'1000'});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState((prevState) => ({
			subscriptions: nextProps.subscriptions,
			buttonsDisabled: false,
			filter: { ...prevState.filter, value: nextProps.query ? nextProps.query.filterString : '' }
		}));
	}

	shouldComponentUpdate(nextProps) {
		if (JSON.stringify(nextProps.query) !== JSON.stringify(this.props.query)) {
			this.props.fetchSubscriptions(nextProps.query);
			return false;
		}
		return true;
	}

	onClickRefresh() {
		this.props.fetchSubscriptions({...this.props.query,status:this.props.status});
	}

	handleSort(sortBy) {
		if (sortBy && sortBy.length > 0 && this.props.sort && this.props.sort.length > 0) {
			const { sort } = this.props;
			const desc = sort[0].direction === 'DESC';

			if (sortBy[0].id !== sort[0].property || sortBy[0].desc !== desc) {
				const newSort = {
					direction: sortBy[0].desc ? 'DESC' : 'ASC',
					property: sortBy[0].id,
					page: 0
				};
				const query = {
					...this.props.query,
					status: this.state.status,
					...newSort
				};
				this.props.onSort(query, this.props.communityId);
			}
		}
	}

	onSelectSize(value) {
		this.props.history.push(`?${stringify({
			...this.props.query,
			status:this.props.status,
			size: value
		})}`);
	}

	closeAdvancedSearch(){
		this.setState({showAdvancedSearch:false})
	}

	onClickAdvanceSearch() {
		this.setState((prevState) => ({
			showAdvancedSearch: !prevState.showAdvancedSearch
		}));
		
		if(this.state.showAdvancedSearch){
			this.discardAdvancedSearch();
			this.props.history.push(`/${this.props.communityId}/subscriptions?${stringify({
				status:this.props.status
			})}`)
		}
		this.sections.common.fields.sendingFacilityDisplayName.options 
			= this.props.sendingFacilities.map((value) => ({ value: value.displayName, label: value.displayName }))
			this.sections.common.fields.sendingFacilityDisplayName.options.unshift({value:'',label:'All'});
	}

	handleInputChange(e) {
		const target = e.target;
		this.setState({
			advancedSearch: Object.assign({}, this.state.advancedSearch, {
				[target.name]: target.value.trim()
			})
		});
	}

	handleSendingFacility(e) {
		this.setState({
			advancedSearch: Object.assign({}, this.state.advancedSearch, {
				sendingFacilityDisplayName: e ? e.value : ''
			}),
			sendingFacilitySelector: e
		});
	}

	discardAdvancedSearch() {
		const emptyAdvancedSearch = {
			providerNpi: '',
			directAddress: '',
			sendingFacilityDisplayName: '',
			firstName: '',
			lastName: '',
			organizationName: ''
		}
		this.setState({
			advancedSearch: emptyAdvancedSearch,
			sendingFacilitySelector: 'All'
		});

		this.props.history.push(`?${stringify({
			...this.props.query,
			...emptyAdvancedSearch

		})}`)
	}

	handleAdvancedSearchSubmit(e) {
		e.preventDefault();
		let advancedSearch = {
			...this.state.advancedSearch,
			sendingFacilityDisplayName: this.state.advancedSearch.sendingFacilityDisplayName === 'All' ? '' : this.state.advancedSearch.sendingFacilityDisplayName
		}
		const query = {
			...this.props.query,
			...advancedSearch,
			filterString: ''
		}

		this.setState((prevState) => ({
			buttonsDisabled: true,
			filter: { ...prevState.filter, value: '' }
		}))
		this.props.history.push(`?${stringify({
			...query
		})}`);
	}

	exportData() {
		this.setState({
			subscriptionsDownloadUrl: `/api/subscriptions/export?${stringify({
					...this.props.query,
					communityId: this.props.communityId,
					endDate: moment().utc().valueOf(),
					status: this.props.status
				})}`
		});
	}

	onClickDelete(id, deleteCallback, e, subscriptionId) {
		const confirmationProps = {
			body: 'Are you sure you wish to delete this subscription?',
			id: `delete-${id}-confirmation`,
			onClickCancel: this.discardConfirmation,
			onClickConfirm: () => {
				this.discardConfirmation();
				this.props.deleteSubscription(id).then((response) => {
					if (!response || !response.error) {
						const subscriptions = { ...this.state.subscriptions };
						const subs = subscriptions.results[subscriptionId].subscriptions;
						if (subs.length === 1 && subs[0].id === id) {
							delete subscriptions.results[subscriptionId];
							subscriptions.ids.splice(subscriptions.ids.indexOf(subscriptionId), 1);
							this.setState({ subscriptions });
							this.props.incrementOpportunityCount(this.props.opportunityCount);
						}
						if (deleteCallback) {
							deleteCallback();
						}
					}
				});
			},
			placement: 'left',
			target: e.currentTarget,
			title: 'Confirm Deletion'
		};
		this.setState({ confirmation: <Confirmation {...confirmationProps} /> });
	}


	onSelectStatusFilter(key, statusDisplay) {
		let statusValue;
		if (statusDisplay === 'Subscribed') {
			statusValue = 1;
		} else if (statusDisplay === 'Unsubscribed') {
			statusValue = 2;
		} else if (statusDisplay === 'Unsubscribed All') {
			statusValue = 16;
		} else if (statusDisplay === 'Internal Domain') {
			statusValue = 32;
		} else if (statusDisplay === 'Deleted') {
			statusValue = 64;
		}
		else {
			statusValue = '';
		}
	    this.setState({status:statusValue});
		this.props.history.push(`?${stringify({
			...this.props.query,
			[key]: statusValue
		})}`);
	}

	discardConfirmation() {
		this.setState({ confirmation: null });
	}

	handleMoreOptionsStyling(row, e) {
		this.setState({
			moreOptionsStyling: {
				rowIndex: row.index,
				title: e.target.title
			}
		})
	}

	npiCommentCreate(npiCommentObject) {
		this.props.createNPIComment(npiCommentObject, this.onClickRefresh);
	}

	npiCommentUpdate(npiCommentId, npiCommentObject) {
		this.props.updateNpiComment(npiCommentId, npiCommentObject, this.onClickRefresh);
	}

	npiCommentDelete(npiCommentId) {
		this.props.deleteNpiComment(npiCommentId, this.onClickRefresh)
	}

	render() {
		const advancedSearchForm = {
			legend: 'Advanced Search',
			primaryButtonLabel: 'Search',
			secondaryButtonLabel:'Clear',
			style: 'bg-light my-3 mx-3',
			buttonsDisabled: this.state.buttonsDisabled,
			onClickDiscard: this.discardAdvancedSearch,
			onSubmit: this.handleAdvancedSearchSubmit
		};

		const disableBasedOnInput = (field) => {
			if (field==='organizationName' && this.state.advancedSearch.organizationName.length === 0 
				&& (this.state.advancedSearch.firstName.length > 0 || this.state.advancedSearch.lastName.length > 0)) {
					return true;
			}
			else if( (field === 'firstName' || field === 'lastName') && this.state.advancedSearch.firstName.length===0 
				&& this.state.advancedSearch.lastName.length===0  && this.state.advancedSearch.organizationName.length > 0) {
					return true;
			}
			return false;
		};
		
		const inputArr = Object.keys(this.sections).map((s) => {
			const common = this.sections[s];
			return (
				<div key={`${common}-fieldset`} className='form-group-control form-row'>
					{common.legend ? <legend>{common.legend}</legend> : null}
					{Object.keys(common.fields).map((f) => {
						const field = common.fields[f];
						const inError = null;
						return (
							<FormGroupInputControl
								control={{
									id: f,
									name: f,
									componentClass: field.component || 'input',
									type: field.inputType || 'text',
									options: field.options,
									onChange: field.onChange || this.handleInputChange,
									value: this.state[field.value]||this.state.advancedSearch[f] || '',
									placeholder: field.placeholder,
									disabled: disableBasedOnInput(f),
									componentRef: ref => (this[field] = ref)
								}}
								helpText={inError ? this.props.exceptions.fields[field] : null}
								key={field}
								label={field.label}
								style={inError ? `has-error ${field.style}` : field.style} // eslint-disable-line react/style-prop-object
							/>
						)
					})}
				</div>
			)
		});
		
		

		const listProps = {
			gridClass: 'd-none',
			rows: [],
			filter: this.state.filter,
			create: {
				id: 'create-subscrition',
				title: 'Create Subscription',
				onClick: this.props.onCreate
			},
			refresh: {
				id: 'refresh-manage-button',
				title: 'Refresh Manage',
				onClick: this.onClickRefresh
			},
			action: {
				id: 'export-subscriptions-button',
				title: 'Export Subscriptions',
				onClick: this.exportData,
				className: 'btn btn-outline-primary my-2 my-sm-0',
				iconName: 'file-excel-o',
				disabled: this.state.subscriptions.results.length === 0
			},
			advancedSearch: {
				show: this.state.showAdvancedSearch,
				form: <Form {...advancedSearchForm} >
						{inputArr}
					  </Form>,
				onClick: this.onClickAdvanceSearch
			},
			isFetching: false,
			updateQueryParam: this.onSelectStatusFilter,
			navDropDowns: [{
				display: this.props.statusDisplay,
				id: 'status',
				title: 'Status Filter',
				options: this.props.statusOptions.map((value) => ({ id: 'status', value })),

			},{
				display: this.props.sizeDisplay,
				id: 'size',
				title: 'Results Per Page',
				options: this.props.sizeOptions.map((value) => ({ id: 'size', value,
				onClick:(id,value)=> this.onSelectSize(value)
			}))
			}],
			pagination: {
				nextPage: this.props.nextPage,
				previousPage: this.props.previousPage,
				startCount: this.props.startCount,
				endCount: this.props.endCount,
				total: this.props.totalCount
			}
		};

		const rows = this.state.subscriptions
			&& !this.props.isFetching && this.state.subscriptions.ids
			? this.state.subscriptions.ids.map((id) => this.state.subscriptions.results[id])
				.map((subscription) => {
					let displayName = '';
					const npiIconDisplay = {
						iconName: 'user-md',
						tooltip: 'Individual',
						iconStyle: 'fa-lg'
					};

					if (subscription.nppesDemographic === undefined) {
						displayName = (<span className='text-center'>--</span>);
					} else if (subscription.nppesDemographic && subscription.nppesDemographic.enumeration_type === 'NPI-2') {
						displayName = subscription.nppesDemographic.organizationName;
						npiIconDisplay.tooltip = 'Organization';
						npiIconDisplay.iconName = 'building';
					} else {
						displayName = `${subscription.nppesDemographic.lastName}, ${subscription.nppesDemographic.firstName}`;
					}

					const npiProps = {
						providerNpi: subscription.npi,
						npiIconDisplay: { ...npiIconDisplay },
						href: subscription.providerNpiRegistryUrl,
						linkAttributes: { target: 'blank' }
					};

					const npiCommentProps = {
						npiCommentId : (typeof subscription.npiComment === 'undefined' || !subscription.npiComment.id) ? '' : subscription.npiComment.id || '',
						communityId: this.props.communityId,
						npi: subscription.npi,
						npiComment: (typeof subscription.npiComment === 'undefined' || !subscription.npiComment.npiComment) ? '' : subscription.npiComment.npiComment || '',
						invalidNpi: (typeof subscription.npi === 'undefined' || subscription.npi) ? false : true,
						npiCommentCreate: this.npiCommentCreate,
						npiCommentUpdate: this.npiCommentUpdate,
						npiCommentDelete: this.npiCommentDelete
					}

					return {
						id: subscription.providerAtSendingFacilityId,
						npi: npiProps,
						name: displayName,
						sendingFacilityDisplayName: subscription.sendingFacilityDisplayName,
						address: <TableAddress {...subscription.nppesDemographic} key={`${subscription.providerAtSendingFacilityId}-demographics`} />,
						subscriptionCreatedDateTime: moment(subscription.subscriptionCreatedDateTime).format('MM/DD/YYYY h:mm A'),			
						subscriptions: <SubscriptionAddresses
							query={this.props.query}
							moreOptionsStyling={this.state.moreOptionsStyling}
							communityId={this.props.communityId}
							communityName={this.props.communityName}
							history={this.props.history}
							subscription={subscription}
							onClickDelete={
								(e, id, deleteCallback) => this.onClickDelete(
									id, deleteCallback, e, subscription.providerAtSendingFacilityId
								)
							}
							onClickOptIn={(id) => this.props.optIn(id)}
							onClickOptOut={(id) => this.props.optOut(id)}
							onClickInactivate={(subscriptionId, communityId, isActive, deleteMultiple) => this.props.deleteSubscriptionWithStatus(subscriptionId, communityId, isActive, deleteMultiple, {...this.props.query,status:this.props.status})}
							onClickSendResubscribeEmail={(id) => this.props.sendResubscribeEmail(id)}
							onClickAddAddress={
								(sub, successCallback, errorCallback) => this.props.addAddress(
									sub, successCallback, errorCallback
								)
							}
						/>,
						npiComments: (
							<NpiComponent npis={npiProps} npiComments={npiCommentProps} />
						),
					};
				}) : [];

		const headers = [
			{
				Header: 'Created',
				accessor: 'subscriptionCreatedDateTime'
			},
			{
				Header: "NPI",
				accessor: "npiComments",
				id: "npi"
			},
			{
				Header: 'Name',
				accessor: 'name'
			},
			{
				Header: 'Sending Facility',
				accessor: 'sendingFacilityDisplayName'
			},
			{
				Header: 'Address',
				accessor: 'address',
				disableSortBy: true
			},
			{
				Header: 'Subscriptions',
				accessor: 'subscriptions',
				disableSortBy: true
			}
		];

		const initialState = {
			sortBy: [
				{
					id: (this.props.sort && this.props.sort[0] && this.props.sort[0].property) || 'subscriptionCreatedDateTime',
					desc: (this.props.sort && this.props.sort[0] && this.props.sort[0].direction) ? this.props.sort[0].direction === 'DESC' : false
				}
			]
		};

		const gridProps = {
			columns: headers,
			className: 'event-list',
			data: rows,
			manualSortBy:true,
			disableMultiSort: true,
			disableSortRemove: true,
			disableMultiRemove: true,
			onSort: (sortBy) => this.handleSort(sortBy),
			initialState,
			onRowClicked: (row,e) => this.handleMoreOptionsStyling(row,e),
			moreOptionsStyling:this.state.moreOptionsStyling
		};

		return (
			<div className='dashboard-subscription-list'>
				<List {...listProps} />
				<LoadingOverlay>
					{this.props.isFetching ? <Loader loading={this.props.isFetching} /> : <SortableTable {...gridProps} />}
				</LoadingOverlay>
				{/* {this.props.isFetching ? <LoadingIndicator /> : <SortableTable {...gridProps} />} */}
				{
					gridProps.data.length === 0 && !this.props.isFetching
						? (
							<div className='well well-lg text-center'>
								<h3>No Results Found</h3>
							</div>
						) : null
				}
				{this.state.confirmation}
				<iframe
					title='Subscriptions Download iFrame'
					name='subscriptions-download-iframe'
					id='subscriptions-download-iframe'
					style={{ display: 'none' }}
					src={this.state.subscriptionsDownloadUrl}
				/>
				<BodyClickListener excludeTargetId="pagination_nav_id" onClick={() => this.setState({ moreOptionsStyling: {}})} />
			</div>
		);
	}
}
SubscriptionList.defaultProps = {
	subscriptions: [],
	sort:[]
};
SubscriptionList.propTypes = {
	/**
	 * Function that deletes a subscription.
	 */
	deleteSubscription: PropTypes.func.isRequired,
	/**
	 * Function that adds an subscription address
	 */
	addAddress: PropTypes.func.isRequired,
	/**
	 * Whether subscription data is being fetched
	 */
	isFetching: PropTypes.bool.isRequired,
	/**
	 * Subscription data
	 */
	subscriptions: PropTypes.shape({
		isFetching: PropTypes.bool,
		ids: PropTypes.arrayOf(PropTypes.string),
		results: PropTypes.object
	}),
	/**
	 * Function that fetches subscriptions
	 */
	fetchSubscriptions: PropTypes.func.isRequired,
	/**
	 * Function that performs the 'opt-in' function
	 */
	optIn: PropTypes.func.isRequired,
	/**
	 * Function that performs the 'opt-out' function
	 */
	optOut: PropTypes.func.isRequired,

	sendResubscribeEmail: PropTypes.func.isRequired,
	/**
	 * Function that updates the missed opportunity count once a subscription is deleted
	 */
	incrementOpportunityCount: PropTypes.func.isRequired,

	onCreate: PropTypes.func.isRequired,
	/**
	 * The sidebar count of opportunities in the queue
	 */
	opportunityCount: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,

	/**
	 * How status are filtered.
	 */
	status: PropTypes.number.isRequired,
	/**
	 * The display for the status dropdown.
	 */
	statusDisplay: PropTypes.string.isRequired,
	/**
	 * The list of options that will populate the status dropdown.
	 */
	statusOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	/**
	 * Function that deletes(inactivates) subscriptions
	 */
	deleteSubscriptionWithStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
	const {
		opportunityCount,
		entities: { subscriptions },
		entities: { sendingFacilities }
	} = state;
	const {
		location,
		match: { params: { id: communityId } }
	} = props;
	const statusOptions = [{
		display: 'All',
		value: ''
	}, {
		display: 'Subscribed',
		value: '1'
	}, {
		display: 'Unsubscribed',
		value: '2'
	}, {
		display: 'Unsubscribed All',
		value: '16'
	},
	{
		display: 'Internal Domain',
		value: '32'
	},
	{
		display: 'Deleted',
		value: '64'
	}];
	const communityName = state.entities.community[communityId].name;
	let query = parse(location.search);
	if (Object.entries(query).length === 0) {
		query.status='1';
		query.page='0';
		query.size='25';
	}
	const sizeOptions = ['25', '50', '100', '200'];
	    let sizeDisplay = query.size;
	// eslint-disable-next-line no-restricted-globals
	if (!query.size || isNaN(query.size)) {
		[sizeDisplay] = sizeOptions;
	}
	const found = statusOptions.find((o) => o.value === query.status);
	return {
		isFetching: subscriptions.isFetching,
		subscriptions,
		communityName,
		opportunityCount,
		component:'subscriptions',
		status: found ? found.value : '',
		statusDisplay: found ? found.display : 'All',
		statusOptions: statusOptions.map((o) => o.display),
		query,
		sizeDisplay,
		sizeOptions,
		history: props.history,
		context: `${communityId}/subscriptions`,
		sendingFacilities: sendingFacilities.ids.map(
			(id) => sendingFacilities.results[id]
		),
	};
};

const mapDispatchToProps = (dispatch, props) => {
	const {
		match: { params: { id: communityId } }
	} = props;

	return {
		/**
		 * Dispatches an action to delete the NPI Comment.
		 *
		 * @param {String} id - npi comment id
		 *
		 */
		deleteNpiComment: (npiCommentId, successCallback, errorCallback) => (dispatch(
			deleteNpiComment(npiCommentId)
		).then((response) => {
			if (response.error) {
				if (errorCallback) {
					errorCallback(response.error.message);
				}
				return;
			}

			if (successCallback) {
				setTimeout(() => successCallback(), 1000);
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'NPI Comment successfully Deleted',
					duration: 3000
				}
			});
		})
		),

		/**
		 * Dispatches an action to update the NPI Comment and fetch opportunities.
		 *
		 * @param {String} id - npi comment id
		 * @param {Object} npiCommentObject - Object that contains updated comment for NPI
		 *
		 */
		updateNpiComment: (npiCommentId, npiCommentObject, successCallback, errorCallback) => (dispatch(
			updateNpiComment(npiCommentId, npiCommentObject)
		).then((response) => {
			if (response.error) {
				if (errorCallback) {
					errorCallback(response.error.message);
				}
				return;
			}

			if (successCallback) {
				setTimeout(() => successCallback(), 1000);
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'NPI Comment successfully updated',
					duration: 3000
				}
			});
		})

		),

		/**
		 * Creates a NPI Comment.  Triggers an alert based on the
		 * response of creating the NPI Comment.
		 *
		 * @param {Object} npiCommentObject - the NPI Comment to create for NPI at community level.
		 */
		createNPIComment: (npiCommentObject, successCallback, errorCallback) => (dispatch(
			createNPIComment(npiCommentObject)
		).then((response) => {
			if (response.error) {
				if (errorCallback) {
					errorCallback(response.error.message);
				}
				return;
			}

			if (successCallback) {
				setTimeout(() => successCallback(), 1000);
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'NPI Comment successfully created',
					duration: 3000
				}
			});
		})),

		deleteSubscription: (id, query) => dispatch(deleteSubscription(
			id,
			{ communityId, ...query }
		)),
		deleteSubscriptionWithStatus: (id, communityId, isActive, deleteMultiple, query) => (dispatch(
			deleteSubscriptionWithStatus(id, communityId, isActive, deleteMultiple, query)
		).then((response) => {
			const exception = response.error;
			const msg = isActive ? ('Subscription successfully Restored. You will have to refresh the page to see the updated view. It may take several minutes to display.')
				: ('Subscription successfully Deleted. You will have to refresh the page to see the updated view. It may take several minutes to display.');
			if (undefined !== exception && exception.status === 507) {
				dispatch({
					type: 'TRIGGER_ALERT',
					alert: {
						type: 'danger',
						dismissable: true,
						children: exception.message,
						html: true
					}
				});
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: msg,
					duration: 5000
				}
			});
		})),
		fetchSubscriptions: (query) => (dispatch(
			fetchSubscriptions(communityId, { communityId, ...query })
		).then((response) => {
			const exception = response.error;
			if (undefined !== exception && exception.status === 507) {
				dispatch({
					type: 'TRIGGER_ALERT',
					alert: {
						type: 'danger',
						dismissable: true,
						children: exception.message,
						html: true
					}
				});
			}
		})),
		optIn: (id, query) => dispatch(subscriptionOptIn(
			id,
			communityId,
			{ communityId, ...query }
		)),
		sendResubscribeEmail: (id) => (dispatch(
			sendResubscribeEmail(id)
		).then((response) => {
			if (response && response.error) {
				return response;
			}

			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'Resubscribe email sent',
					duration: 5000
				}
			});
		})),
		incrementOpportunityCount: (opportunityCount) => dispatch({
			type: 'RECEIVE_OPPORTUNITY_COUNT',
			count: opportunityCount + 1
		}),

		onCreate: () => props.history.push(`/${props.match.params.id}/subscriptions/add${props.location.search}`),

		/**
	 		* Makes a fetch request for the list of sending facilities.
	 	*/
		fetchSendingFacilities: (query) => dispatch(loadFacilities({ communityId, ...query })),
		addAddress: (subscription,
			successCallback, errorCallback) => (dispatch(createSubscription(subscription))
				.then((response) => {
					if (response.error) {
						if (errorCallback) {
							errorCallback(response.error.fields.email);
						}
						return;
					}
					if (successCallback && response.response) {
						successCallback(response.response);
					}
					dispatch({
						type: 'TRIGGER_ALERT',
						alert: {
							type: 'success',
							dismissable: true,
							message: 'Subscription created successfully',
							duration: 5000
						}
					});
				})),
		optOut: (id, query) => dispatch(
			subscriptionOptOut(id, communityId, { communityId, ...query })
		),
		onSort: (query,communityId) => props.history.push(`/${communityId}/subscriptions?${stringify(query)}`),
		communityId
	};
};

const SubscriptionListContainer = connectedComponent(SubscriptionList, mapStateToProps, mapDispatchToProps,true,true);

export { SubscriptionListContainer as default, SubscriptionList };
